import React, { Component } from 'react'

import {
  getCategories,
  deleteCategory,
  reoderCategories
} from '../../services/api'

import List from '../../components-utils/List'

export default class Values extends Component {
  render() {
    return (
      <List
        getItems={getCategories}
        deleteItem={deleteCategory}
        reorderItem={reoderCategories}
        path="/categories"
        elementName="catégorie"
        elementGender="f"
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/categories/Categories.js